<template>
    <div class="dealer-keyword-search form-group">
        <label class="dealer-keyword-search__filter__label form__label" for="dealer-keyword-search__keyword-name">{{ $t('global-dealer-search.keyword') }}</label>
        <div class="dealer-keyword-search__input--suggestions-wrapper">
            <input v-model="keyword" id="dealer-keyword-search__keyword-name" @keyup.prevent="setSuggestion" @focus="selected = false"
                   class="form__input form__input--text" type="text">
            <template v-if="suggestions.length && !selected">
                <div class="dealer-keyword-search__input--suggestion">
                    <template v-for="(suggestion, index) in suggestions.slice(0,this.maxSuggestions)">
                        <p :class="highlightedSuggestion === index ? 'dealer-keyword-search__suggestion--active': ''"
                           @click="setKeyword(index)"><span v-html="highlightSuggestion(suggestion)"></span> <span>({{ suggestion.dealerships.length }})</span>
                        </p>
                        <template v-if="index === maxSuggestions -1 && index < suggestions.length">
                            <p @click="maxSuggestions += 5" class="dealer-keyword-search__show-more">
                                {{ $t('global-dealer-search.loadMore') }}
                            </p>
                        </template>
                    </template>
                </div>
            </template>
        </div>
        <div class="button-wrapper right">
            <global-button theme="primary" @click="searchByKeyword()">{{ $t('global-dealer-search.button.search') }}</global-button>
        </div>
    </div>
</template>

<script>
import GlobalButton from "@global/global-elements/global-button/global-button";

export default {
        name: "dealer-keyword-search",
        components: {GlobalButton},
        props: {
            dealers: {}
        },
        data() {
            return {
                keyword: null,
                selected: false,
                highlightedSuggestion: null,
                maxSuggestions: 10
            }
        },
        computed: {
            suggestions() {
                let searchResults = [];

                if (this.keyword) {
                    this.dealers.forEach(dealer => {
                        const result = dealer.name.toLocaleLowerCase().search(this.keyword.toLocaleLowerCase());
                        if (result !== -1) {
                            if (searchResults.length !== 0) {
                                let found = false;
                                searchResults.forEach(searchResult => {
                                    if (searchResult.name === dealer.name) {
                                        found = true;
                                        searchResult.dealerships.push(dealer);
                                    }
                                });
                                if (!found) {
                                    searchResults.push({
                                        name: dealer.name,
                                        dealerships: [dealer]
                                    });
                                }
                            } else {
                                searchResults.push({
                                    name: dealer.name,
                                    dealerships: [dealer]
                                });
                            }
                        }
                    });
                }

                searchResults.sort((a, b) => {
                    const nameA = a.name.toLocaleLowerCase();
                    const nameB = b.name.toLocaleLowerCase();

                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }

                    return 0;
                });

                return searchResults
            }
        },
        methods: {
            setKeyword(index) {
                this.keyword = this.suggestions[index].name;
                this.selected = true;
            },
            highlightSuggestion(suggestion) {
                if (this.keyword.length < 3) {
                    return suggestion.name
                } else {
                    return suggestion.name.replace(new RegExp('(' + this.keyword + ')', 'i'), '<span class="dealer-keyword-search__suggestion--highlight">$1</span>');
                }
            },
            setSuggestion(e) {
                if (e.key !== 'Escape' && e.key !== 'Enter') {
                    this.selected = false;
                }

                if (e.key === 'Escape') {
                    this.selected = true;
                }

                if (this.keyword.length && this.selected === true && e.key === 'Enter') {
                    this.searchByKeyword();
                }

                if (this.highlightedSuggestion !== null) {
                    if (e.key === 'Enter') {
                        this.setKeyword(this.highlightedSuggestion);
                    }
                    if (e.key === 'ArrowUp') {
                        this.highlightedSuggestion--;
                    }
                    if (e.key === 'ArrowDown') {
                        this.highlightedSuggestion++;
                    }
                    switch (true) {
                        case (this.highlightedSuggestion < 0):
                            this.highlightedSuggestion = this.suggestions.length - 1;
                            break;
                        case (this.highlightedSuggestion > this.suggestions.length - 1):
                            this.highlightedSuggestion = 0;
                            break;
                        default:
                            break;
                    }
                } else {
                    if (e.key === 'Enter') {
                        if (this.selected === true && this.keyword.length) {
                            this.searchByKeyword();
                        } else {
                            this.selected = true;
                        }

                    }

                    if (e.key === 'ArrowUp') {
                        this.highlightedSuggestion = this.suggestions.length - 1;
                    }

                    if (e.key === 'ArrowDown') {
                        this.highlightedSuggestion = 0;
                    }
                }
            },
            searchByKeyword() {
                if (this.suggestions.length) {
                    let dataPoints = [];
                    this.suggestions.forEach(suggestion => {
                        dataPoints = dataPoints.concat(suggestion.dealerships);
                    });

                    this.$emit('updateDealers', dataPoints);
                }
            },
        },
        mounted() {
            this.$store.dispatch('setCountry', null);
            this.$store.dispatch('setDealerResults', null)
        },
        created() {
            let self = this;
            document.addEventListener('click', e => {
                if (!self.$el.contains(e.target)) {
                    self.selected = true;
                }
            });
        }
    }
</script>
